<p-card>
    <ng-template pTemplate="header">
        <div class="p-3 flex justify-between">
            <h2 class="text-xl font-semibold">PPM Call Stats</h2>
            <ng-container *ngIf="canEditPpmCallGoals()">
                <app-icon-button 
                    [icon]="icons.solid.faGear" 
                    tooltip="Update PPM Call Goals" 
                    tooltipPosition="top"
                    (click)="updateCallGoals()"
                ></app-icon-button>
            </ng-container>
        </div>
    </ng-template>
    <div class="flex flex-col md:flex-row gap-5 items-stretch">
        <div class="w-full md:w-1/2">
            <app-call-progress></app-call-progress>
        </div>
        <div class="w-full md:w-1/2">
            <app-call-stats-graph></app-call-stats-graph>
        </div>
    </div>
</p-card> 